import { useParams } from 'react-router-dom';

import { Breadcrumb, BreadcrumbData } from '@/components/Breadcrumbs';

import { useDataset } from '../../hooks/useSwr';
import DatasetIcon from '../../icons/DatasetIcon';

export function DatasetCrumb(props: Partial<BreadcrumbData>) {
  const { datasetId, evaluatorId } = useParams();
  const dataset = useDataset(datasetId!);
  const path = evaluatorId ? `${props.path}?tab=2` : props.path;

  return (
    <Breadcrumb
      icon={<DatasetIcon />}
      name={dataset.data?.name ?? ''}
      {...props}
      path={path}
    />
  );
}
